<template>
  <div
    class="w-100 h-100 receipt-item"
    :key="resourceId"
  >
    <div
      class=" d-flex justify-content-center align-items-center w-100 h-100"
      v-if="downloading"
    >
      <spinner></spinner>
    </div>
    <template v-else>
      <object
        v-if="resourceData.mimeType==='application/pdf'"
        :data="imgResource"
        type="application/pdf"
        width="100%"
        height="100%"
        name="pdf"
      >
      </object>
      <div
        class="img-large"
        v-else
      >
        <img
          alt="image-resource-receipt"
          :src="imgResource"
          width="100%"
          height="auto"
        >
      </div>
    </template>
    <div :class="controlButtonsClasses">
      <button
        v-if="!isExpense"
        class="Fuell-Button blue"
        @click.prevent="downloadFile"
      >{{ $t(downloadLink)}}</button>
      <button
        class="Fuell-Button red ml-2"
        v-if="!hideDelete"
        @click.prevent="deleteFile"
      >{{ $t(deleteLink)}}</button>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Commons/Spinner'
// import pdf from 'vue-pdf'
import _mediaResourceHandler from '@/components/Commons/_mixins/_mediaResourceHandlerMixin'
import { getResourceFromAws } from '@/shared/_api'

export default {
  name: 'TransactionReceiptItem',
  components: { Spinner },
  mixins: [_mediaResourceHandler],
  props: {
    file: {
      default: null
    },
    resourceData: {
      type: Object
    },
    imageAlt: {
      type: String
    },
    resourceId: { default: false },
    resourceIndex: { type: Number },
    showResourceLink: {
      type: Boolean,
      default: true
    },
    hideDelete: {
      type: [Boolean, String],
      default: false
    },
    deleting: {
      type: Boolean,
      default: false
    },
    useEmbed: {
      type: Boolean,
      default: false
    },
    isExpense: {
      type: Boolean,
      default: false
    },
    horizontal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fetchedResource: null,
      fetchedResourceLink: null,
      resourceType: null,
      downloading: false,
      downloadingFile: false,
      pdfNumPages: undefined,
      showControls: false,
      currentPage: 1,
      progress: 0
    }
  },
  computed: {
    imgResource () {
      return this.fetchedResource
    },
    downloadLink () {
      return this.downloadingFile ? 'media_viewer_fetching_resource' : 'media_viewer_fetch_resource'
    },
    deleteLink () {
      return this.deleting ? 'media_viewer_deleting_resource' : 'media_viewer_delete_resource'
    },
    controlButtonsClasses () {
      return this.horizontal ? 'control-buttons my-2 text-center justify-content-center' : 'control-buttons mt-2 mb-4 text-center justify-content-center'
    }
  },
  methods: {
    // async fetchImage () {
    //   if (this.resourceId) {
    //     if (this.downloading) return
    //     this.downloading = true
    //     try {
    //       const fetchedResource = await getMedia(this.resourceId)
    //       let reader = new FileReader()
    //       reader.onload = () => {
    //         this.fetchedResource = reader.result
    //       }
    //       reader.readAsDataURL(fetchedResource.data)
    //       this.resourceType = fetchedResource.type
    //     } catch (error) {
    //       console.error('Fetch Image error', error)
    //     } finally {
    //       this.downloading = false
    //     }
    //   }
    // },
    async downloadFile () {
      if (this.downloadingFile) return
      this.downloadingFile = true
      try {
        const fetchedResource = await getResourceFromAws(this.resourceId)
        this.fetchedResourceLink = document.createElement('a')
        this.fetchedResourceLink.href = URL.createObjectURL(fetchedResource.data)
        const resourceUrl = new URL(encodeURI(fetchedResource.request.responseURL))
        const resourceParams = resourceUrl.searchParams.get('response-content-disposition')
        const resourceName = resourceParams.substring(resourceParams.indexOf('filename') + 11, resourceParams.length)
        this.fetchedResourceLink.download = resourceName || 'resource-' + this.resourceId
        this.$emit('resourceDownloaded', this.resourceId)
      } catch (error) {
        console.error('Download File error', error)
      } finally {
        this.downloadingFile = false
        this.fetchedResourceLink.click()
      }
    },
    async deleteFile () {
      if (this.deleting) return
      if (this.resourceId) {
        this.$emit('handleDelete', this.resourceId)
      } else {
        this.$emit('handleDelete', this.resourceIndex)
      }
    },
    emitResourceId () {
      this.$emit('emitResourceId', this.resourceId)
    },
    showLinks () {
      this.showControls = true
    }
  },
  created () {
    this.fetchImage()
  },
  watch: {
    resourceId (v) {
      if (!this.file) {
        this.fetchImage()
      }
      this.currentPage = 1
    },
    file (v) {
      this.fetchImage()
    }
  }

}
</script>

<style>
.receipt-item {
  width: 100%;
  max-height: 95%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.img-large {
  width: 100%;
  height: auto;
  overflow: auto;
}
@media screen and (max-width: 768px) {
  .receipt-item {
    flex: 1 1 75%;
    max-height: 75%;
  }
}
</style>
